import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { getScrollTriggerRefreshPriority } from './scroll-trigger-priority'

gsap.registerPlugin(ScrollTrigger)

export function initAnimatedCircle(root = document) {
    const scope = root instanceof Element ? root : document
    const circles = scope.querySelectorAll('[data-animated-circle]')

    if (!circles.length) return

    const prefersReduced = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches

    const ctx = gsap.context(() => {
        circles.forEach((circle) => {
            if (circle.dataset.animatedCircleInitialized === 'true') return
            circle.dataset.animatedCircleInitialized = 'true'

            const shape =
                circle.querySelector('[data-animated-circle-shape]') || circle
            const trigger = circle.nextElementSibling || circle
            const getWidth = () => {
                const circleWidth = circle.getBoundingClientRect().width
                return Math.max(circleWidth * 1.18, 1024)
            }

            if (prefersReduced) {
                gsap.set(shape, {
                    xPercent: -50,
                    width: getWidth(),
                    clipPath: 'ellipse(50% 96% at 50% 100%)'
                })
                return
            }

            gsap.fromTo(
                shape,
                {
                    xPercent: -50,
                    width: () => getWidth(),
                    clipPath: 'ellipse(58% 82% at 50% 100%)'
                },
                {
                    xPercent: -50,
                    width: () => getWidth(),
                    clipPath: 'ellipse(50% 96% at 50% 100%)',
                    ease: 'none',
                    scrollTrigger: {
                        refreshPriority:
                            getScrollTriggerRefreshPriority(circle),
                        trigger,
                        start: 'top 100%',
                        end: 'center 80%',
                        scrub: true,
                        invalidateOnRefresh: true
                        // markers: true
                    }
                }
            )
        })
    }, scope)

    return () => ctx.revert()
}
